import { render, staticRenderFns } from "./FormControlSelectSimple.vue?vue&type=template&id=04c0a8a8&"
import script from "./FormControlSelectSimple.vue?vue&type=script&lang=js&"
export * from "./FormControlSelectSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports